import { render } from "./Lead.vue?vue&type=template&id=2dad3eb2&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Lead.vue?vue&type=style&index=0&id=2dad3eb2&lang=scss&module=true"
cssModules["$style"] = style0
import "./Lead.vue?vue&type=style&index=1&id=2dad3eb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-2dad3eb2"]])

export default __exports__